// @flow
import { createAction } from 'redux-actions';
import type { ActionType } from 'types/redux';
import type { IValetDetails } from './IValetDetails';

export const SET_VALET_DETAILS = 'appointment/valetDetails/SET_VALET_DETAILS';
export const setValetDetails = createAction(
  SET_VALET_DETAILS,
  (valetDetails: IValetDetails) => valetDetails
);

export const SET_DROP_OFF_ADDRESS =
  'appointment/valetDetails/SET_DROP_OFF_ADDRESS';
export const setDropoffAddress = createAction(
  SET_DROP_OFF_ADDRESS,
  (dropoffAddress: string) => dropoffAddress
);

export const SET_DROP_OFF_ADDRESS_TYPE =
  'appointment/valetDetails/SET_DROP_OFF_ADDRESS_TYPE';
export const setDropoffAddressType = createAction(
  SET_DROP_OFF_ADDRESS_TYPE,
  (dropoffAddressType: string) => dropoffAddressType
);

export const SET_PICK_UP_ADDRESS =
  'appointment/valetDetails/SET_PICK_UP_ADDRESS';
export const setPickupAddress = createAction(
  SET_PICK_UP_ADDRESS,
  (pickupAddress: string) => pickupAddress
);

export const SET_PICK_UP_ADDRESS_TYPE =
  'appointment/valetDetails/SET_PICK_UP_ADDRESS_TYPE';
export const setPickupAddressType = createAction(
  SET_PICK_UP_ADDRESS_TYPE,
  (pickupAddressType: string) => pickupAddressType
);

export const SET_VALET_COMMENTS = 'appointment/valetDetails/SET_VALET_COMMENTS';
export const setValetComments = createAction(
  SET_VALET_COMMENTS,
  (comments: string) => comments
);

export const SET_PHONE_NO = 'appointment/valetDetails/SET_PHONE_NO';
export const setPhoneNo = createAction(
  SET_PHONE_NO,
  (phoneNo: string) => phoneNo
);

export const SET_PHONE_TYPE = 'appointment/valetDetails/SET_PHONE_TYPE';
export const setPhoneType = createAction(
  SET_PHONE_TYPE,
  (phoneType: string) => phoneType
);

export const SET_DROPOFF_PREFERENCE =
  'appointment/valetDetails/SET_DROPOFF_PREFERENCE';
export const setDropoffPreference = createAction(
  SET_DROPOFF_PREFERENCE,
  (dropoffPreference: string) => dropoffPreference
);

export type Action =
  | ActionType<typeof setValetDetails>
  | ActionType<typeof setDropoffAddress>
  | ActionType<typeof setDropoffAddressType>
  | ActionType<typeof setPickupAddress>
  | ActionType<typeof setPickupAddressType>
  | ActionType<typeof setValetComments>
  | ActionType<typeof setPhoneNo>
  | ActionType<typeof setPhoneType>
  | ActionType<typeof setDropoffPreference>;



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/valetDetails/actions.js